import { Flex, FlexProps, Text, defineStyle } from '@chakra-ui/react';
import { ClaimButton } from './ClaimButton';
import { cratName } from '../../constants/cratD2CLogoLink';
import { CratIcon } from '../CratIcon/CratIcon';
import React from 'react';

const totalDailyLimitBlockStyle = defineStyle({
  w: '100%',
  py: '24px',
  px: '16px',
  flexDirection: 'column',
  alignItems: 'center',
  border: '1px solid',
  borderColor: 'borderGrey.100',
  borderRadius: '12px',
  gap: '12px',
  transition: 'background, border',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'ease-in-out',
  _hover: { borderColor: 'green.100', backgroundColor: 'greenA.900' },
}) as FlexProps;

type Props = {
  totalDailyLimit: string;
  userDailyLimit: string;
};

export const UserDailyLimitBlock = React.memo(({ userDailyLimit, totalDailyLimit }: Props) => {
  return (
    <Flex {...totalDailyLimitBlockStyle}>
      <Text as={'span'} fontSize={'12px'} fontWeight={400} lineHeight={'24px'}>
        Your Daily Limit
      </Text>
      <Flex alignItems={'center'} gap={'8px'}>
        <CratIcon w={'24.5px'} h={'27.5px'} />
        <Text as={'span'} fontSize={{ base: '16px', sm: '20px' }} fontWeight={400} lineHeight={'40px'}>
          {userDailyLimit} {cratName}
        </Text>
      </Flex>
      <ClaimButton totalDailyLimit={totalDailyLimit} userDailyLimit={userDailyLimit} />
    </Flex>
  );
});
